import React, { useEffect, useState } from "react";
import {
    collection,
    query,
    orderBy,
    where,
    deleteDoc,
    onSnapshot,
    doc,
    getDoc,
    updateDoc,
    arrayUnion,
    arrayRemove,
} from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";

const PostList = ({ filterType = null, userId = null }) => {
    const { currentUser } = useAuth();
    const [posts, setPosts] = useState([]);
    const [usersCache, setUsersCache] = useState({});

    const handleDelete = async (postId) => {
        if (window.confirm("Удалить этот пост?")) {
            try {
                await deleteDoc(doc(db, "posts", postId));
            } catch (error) {
                alert("Ошибка при удалении: " + error.message);
            }
        }
    };

    const toggleLike = async (postId, likes) => {
        const postRef = doc(db, "posts", postId);
        const isLiked = likes.includes(currentUser.uid);

        try {
            await updateDoc(postRef, {
                likes: isLiked
                    ? arrayRemove(currentUser.uid)
                    : arrayUnion(currentUser.uid),
            });
        } catch (error) {
            console.error("Ошибка при лайке:", error);
        }
    };

    useEffect(() => {
        let q;
        const base = collection(db, "posts");

        if (filterType && userId) {
            q = query(
                base,
                where("type", "==", filterType),
                where("userId", "==", userId),
                orderBy("createdAt", "desc")
            );
        } else if (filterType) {
            q = query(base, where("type", "==", filterType), orderBy("createdAt", "desc"));
        } else if (userId) {
            q = query(base, where("userId", "==", userId), where("type", "==", "feed"), orderBy("createdAt", "desc"));
        } else {
            q = query(base, where("type", "==", "feed"), orderBy("createdAt", "desc"));
        }

        const unsubscribe = onSnapshot(q, async (querySnapshot) => {
            const postsArr = [];
            const newUsersCache = { ...usersCache };

            for (const docSnap of querySnapshot.docs) {
                const postData = docSnap.data();
                const uid = postData.authorId || postData.userId;

                if (!newUsersCache[uid]) {
                    const userRef = doc(db, "users", uid);
                    const userSnap = await getDoc(userRef);
                    newUsersCache[uid] = userSnap.exists()
                        ? userSnap.data()
                        : { displayName: "Неизвестный", avatarUrl: "" };
                }

                postsArr.push({
                    id: docSnap.id,
                    ...postData,
                    user: newUsersCache[uid],
                    likes: postData.likes || [],
                });
            }

            setUsersCache(newUsersCache);
            setPosts(postsArr);
        });

        return () => unsubscribe();
    }, [filterType, userId]);

    return (
        <div style={{ maxWidth: "1000px", margin: "0 auto" }} className="background-generalWall">
            {posts.length === 0 && <p>Постов пока нет.</p>}

            {posts.map((post) => {
                const canDelete = currentUser?.uid === post.authorId || currentUser?.uid === post.userId;

                return (
                    <div
                        key={post.id}
                        style={{
                            marginBottom: "8px",
                            padding: "5px",
                            border: "3px solid #620075ff",
                            borderRadius: "8px",
                            position: "relative",
                        }}
                    >
                        {/* Верхняя строка с аватаром и именем как ссылка */}
                        <Link
                            to={`/wall/${post.authorId || post.userId}`}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: "10px",
                                textDecoration: "none",
                                color: "inherit",
                            }}
                        >
                            {post.user?.avatarUrl && (
                                <img
                                    src={post.user.avatarUrl}
                                    alt="аватар"
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                        marginRight: "10px",
                                    }}
                                />
                            )}
                            <div className="nickname">
                                {post.user?.displayName || post.email}
                            </div>
                        </Link>

                        {/* Текст поста */}
                        <div className="textPost">
                            {post.text || post.content}
                        </div>

                        {/* Нижняя строка с кнопками и датой */}
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            marginTop: "15px"
                        }}>
                            {/* Кнопка лайка */}
                            <button
                                onClick={() => toggleLike(post.id, post.likes)}
                                className="like-button"
                                style={{ margin: 0 }}
                            >
                                ❤️ {post.likes.length}
                            </button>

                            {/* Правая часть с датой и кнопкой удаления */}
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div className="dateText" style={{ marginRight: "15px" }}>
                                    {post.createdAt?.toDate?.().toLocaleString() || "Сейчас"}
                                </div>

                                {canDelete && (
                                    <button
                                        onClick={() => handleDelete(post.id)}
                                        className="delete-button"
                                        style={{ margin: 0 }}
                                    >
                                        🗑️ Удалить
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default PostList;
